import React from 'react';

export const LabeledTextarea = ({ label, onChange, className, value }) => (
    <div className={className}>
        <span className={'textarea-label'}>{label}</span>
        <textarea
            onChange={({ target }) => onChange(target.value)}
            value={value || ''}
        />
    </div>
);
